<div class="collapse mobileMenu" id="mobileNav">
  <div class="menuWrap">
    <div class="d-flex justify-content-between mb-5">
      <div class="brandLogo">
        <img width="150px" src="assets/images/logo/confe-light-web.svg" alt="" class="lightLogo" />
      </div>
      <button
        type="button"
        data-toggle="collapse"
        data-target="#mobileNav"
        aria-expanded="false"
        aria-controls="mobileNav"
        class="bg-transparent p-1 border-0"
      >
        <i class="pi pi-times"></i>
      </button>
    </div>
    <ul class="nav flex-column">
      <li class="nav-item">
        <a class="nav-link active" [routerLink]="['/']">
          <img class="mr-2" src="/assets/images/menu/dashboard.svg" alt="" />
          Dashboard
        </a>
      </li>
      <li class="nav-item">
        <a
          class="nav-link d-flex align-items-center"
          href="#"
          data-toggle="collapse"
          href="#p1"
          role="button"
          aria-expanded="false"
          aria-controls="p1"
        >
          <img class="mr-2" src="/assets/images/menu/edit.svg" alt="" />
          Post
          <i class="pi pi-angle-down ml-auto"></i>
        </a>
        <div class="collapse" id="p1">
          <ul class="nav flex-column pl-3">
            <li class="nav-item">
              <a class="nav-link" [routerLink]="['/create']">
                <img alt="" class="mr-2" src="/assets/images/menu/list.svg" /> Create Post
              </a>
            </li>
            <li>
              <a class="nav-link" [routerLink]="['/post-schedule']">
                <img alt="" class="mr-2" src="/assets/images/menu/calendar.svg" /> Post queue
              </a>
            </li>
          </ul>
        </div>
      </li>
      <li class="nav-item">
        <a
          class="nav-link d-flex align-items-center"
          href="#"
          data-toggle="collapse"
          href="#p2"
          role="button"
          aria-expanded="false"
          aria-controls="p2"
        >
          <img alt="" class="mr-2" src="/assets/images/menu/calendar.svg" />
          Planning
          <i class="pi pi-angle-down ml-auto"></i>
        </a>
        <div class="collapse" id="p2">
          <ul class="nav flex-column pl-3">
            <li class="nav-item">
              <a class="nav-link" [routerLink]="['/planner/list']">
                <img alt="" class="mr-2" src="/assets/images/menu/list.svg" /> Posts List
              </a>
            </li>
            <li>
              <a class="nav-link" [routerLink]="['/planner/calendar']">
                <img alt="" class="mr-2" src="/assets/images/menu/calendar.svg" /> Calendar
              </a>
            </li>
          </ul>
        </div>
      </li>
      <li class="nav-item">
        <a
          class="nav-link d-flex align-items-center"
          href="#"
          data-toggle="collapse"
          href="#p3"
          role="button"
          aria-expanded="false"
          aria-controls="p3"
        >
          <img class="mr-2" src="/assets/images/menu/ai-prompts.svg" alt="" />
          Prompts
          <i class="pi pi-angle-down ml-auto"></i>
        </a>
        <div class="collapse" id="p3">
          <ul class="nav flex-column pl-3">
            <li class="nav-item">
              <a class="nav-link" [routerLink]="['/ai/ai-writer']">
                <img alt="" class="mr-2" src="/assets/images/menu/list.svg" /> AI Prompts
              </a>
            </li>
          </ul>
        </div>
      </li>
      <li class="nav-item">
        <a class="nav-link" [routerLink]="['/analytics']">
          <img class="mr-2" src="/assets/images/menu/report.svg" alt="" />
          Analytics
        </a>
      </li>
      <li class="nav-item">
        <a
          class="nav-link"
          [routerLink]="['/workspace/settings']"
          [queryParams]="{ selectedTab: 'connected-accounts' }"
        >
          <i class="pi pi-link mr-2" style="font-size: 1.1rem"></i>
          Connections
        </a>
      </li>
      <li class="nav-item">
        <a class="nav-link" [routerLink]="['/workspace/settings']">
          <img class="mr-2" src="/assets/images/menu/setting.svg" alt="" />
          Workspace Settings
        </a>
      </li>
      @if (showUpgradeNav()) {
        <li class="nav-item">
          <a
            class="nav-link nav-link--upgrade"
            [routerLink]="['/plans']"
            [queryParams]="{ id: selectedWorkspace?.uuid }"
          >
            <img
              src="/assets/images/menu/upgrade-nav.svg"
              alt="Upgrade plan"
              width="20"
              height="20"
              class="mr-2"
            />
            Upgrade plan
          </a>
        </li>
      }

      <li class="nav-item">
        <a
          class="nav-link d-flex align-items-center"
          href="#"
          data-toggle="collapse"
          href="#p5"
          role="button"
          aria-expanded="false"
          aria-controls="p4"
        >
          <img class="mr-2" src="/assets/images/menu/faq.svg" alt="" />
          Help & Support
          <i class="pi pi-angle-down ml-auto"></i>
        </a>
        <div class="collapse" id="p5">
          <ul class="nav flex-column pl-3">
            <li class="nav-item">
              <a target="_blank" href="https://confe.io/terms">Terms</a>
            </li>
            <li class="nav-item">
              <a target="_blank" href="https://confe.io/privacy">Privacy & Security</a>
            </li>
            <li class="nav-item">
              <a target="_blank" href="https://confe.io/privacy">Privacy & Security</a>
            </li>
            <li class="nav-item">
              <a class="nav-link pt-0" href="#">
                <div class="support pt-3">
                  <h6>Contact Support</h6>
                  <p class="mb-2">24/7 help from support staff</p>
                  <a href="https://confe.io/contact" target="_blank">
                    <p-button styleClass="contactBtn" label="Contact" [raised]="true"></p-button>
                  </a>
                </div>
              </a>
            </li>
          </ul>
        </div>
      </li>

      <!--<li class="nav-item">
        <a
          class="nav-link d-flex align-items-center"
          data-toggle="collapse"
          role="button"
          aria-expanded="false"
          aria-controls="p5"
        >
          <img class="mr-2" src="/assets/images/menu/faq.svg" alt="" />
          Help & Support
          <i class="pi pi-angle-down ml-auto"></i>
        </a>
        <div class="collapse" id="p5">
          <ul class="nav flex-column pl-3">
            <li class="nav-item">
              <a class="nav-link" href="#">Privacy & Security</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="">Other Topics</a>
            </li>
            <li class="nav-item">
              <a class="nav-link pt-0" href="#">
                <div class="support pt-3">
                  <h6>Contact Support</h6>
                  <p class="mb-2">24/7 help from support staff</p>
                  <p-button styleClass="contactBtn" label="Contact" [raised]="true"></p-button>
                </div>
              </a>
            </li>
          </ul>
        </div>
      </li>-->
    </ul>
  </div>
</div>
